import FeedWidget from './widget-variants/feed';
// This is a register function for the feed widget
(function () {
    // Register the widget to the window
    window._mensenlinq = window._mensenlinq || {};
    window._mensenlinq.feed = window._mensenlinq.feed || FeedWidget;
    window._mensenlinq.commitHash = '1';
    // Locations to append this widget
    var widgets = document.querySelectorAll('[data-mensenlinq]');
    // Execute widget
    var src = document.currentScript.src;
    var urlParams = new URLSearchParams(src.split('?')[1]);
    var customerId = urlParams.get('customerId');
    // empty config. will be overwritten by widgetBootstrap.ts (defaults) and widgetConfig.ts (DOM overwrites)
    var config = {
        layout: [],
        _customerId: customerId,
    };
    widgets.forEach(function (widgetDom) {
        widgetDom.removeAttribute('data-mensenlinq');
        window._mensenlinq.feed(config, widgetDom);
    });
})();
